<template>
  <div class="home">
      <div class="header">
          <headerShow @changeLanguage="changeLanguageFN"></headerShow>
      </div>
      <div class="homeBody newsDetailMargin">
          <div class="forTopHeight"></div>
          <div class="htmlBoldTitle">{{title}}<div class="htmlcommenTime">{{reporterVal}}</div></div>
          <div class="forLine"></div>
          <!-- <div class="htmlcommenTime">{{reporterVal}}</div> -->
          <div class="markdown-body ql-editor" v-html="htmlContent"/>
      </div>

      <footerView></footerView>
  </div>
</template>

<script>
// import swiper from '@/components/swiper.vue'
import footerView from '@/components/footer.vue'
import headerShow from '@/components/headerShow.vue'
import { newsDetailRequest } from '../request/request'
export default {
  name: 'detail',
  components: {
    footerView, headerShow
    // swiper
  },
  data () {
    return {
      htmlContent: '',
      title: '',
      id: '',
      languageVal: 'ch'
    }
  },
  computed: {

  },
  mounted () {
  },
  created () {
    this.$nextTick(() => {
      this.languageVal = localStorage.getItem('language') === 'en' ? 'en' : 'ch'
      this.initFN()
      document.scrollingElement.scrollTop = 0
    })
  },
  methods: {
    async newsDetailRequestFN (e) {
      var res = await newsDetailRequest(e)
      if (res.data.code === 0) {
        debugger
        this.htmlContent = res.data.data.content
        this.$nextTick(() => {
          var a = document.querySelector('.markdown-body').querySelectorAll('img')
          var b
          for (var i = 0; i < a.length; i++) {
            b = a[i]
            b.parentNode.style.textAlign = 'center'
          }
        })
        this.title = res.data.data.title

        var time = res.data.data.publishDate ? res.data.data.publishDate.substring(0, 10) : ''
        var name = res.data.data.announcer ? res.data.data.announcer : ''
        this.reporterVal = name + ' ' + time// res.data.data.publishDate.substring(0, 10)
      }
    },
    changeLanguageFN (e) {
      this.languageVal = e === 'en' ? 'en' : 'ch'
      localStorage.language = this.languageVal
      this.initFN()
    },
    initFN () {
      this.id = this.$route.query.id
      this.newsDetailRequestFN({ id: this.id, lang: this.languageVal })
    }
  }
}
</script>
<style lang="scss">
.newsDetailMargin{
    padding-top: 15px;
}
.htmlBoldTitle{
    background-image: url('../assets/bigLogo.png');
    background-repeat:no-repeat ;
    width: 90%;
    margin: 0 auto;
}
.markdown-body{
    width: 90%;
    margin: 0 auto;
    background: white;
    text-align:unset;
    min-height: 75vh;
    padding-top: 20px;
}
.resultPage{
    margin: 15px 0;
    @include bottomLine
}
.resultMark{
    width:15.6vw;
    min-width:160px;
}
// .resultTitle{
//     height: 5vh;
//     min-height: 20px;
//     font-size: 12px;
//     @include centerLine;
//     align-items: flex-start;
// }
.resultItem{
    @include fullbackground;
    margin-bottom: 1vh;
    width:15.6vw;
    height: 8.84vw;
    min-width:160px;
    min-height: 90.6px;
    // background-image: url('../assets/1.png');

}
.resultContent{
    width: 100%;
    min-height: 30vh;
    @include startLine;
    justify-content:space-around;
    flex-wrap: wrap;
    margin-top:3vh;
}

.ivu-tag{
    cursor:pointer
}
.selectOptionAll{
    width: 90%;
    margin:0 auto;
    .selectTitle{
        width: 5vw;
        @include betweenLine;
        min-width: 80px;
        font-size: 16px;
        margin-right: 5vw;
        font-weight: bold;
    }
    .selectOption{
        @include startLine;
        align-items:flex-start;
        flex-wrap: nowrap;
        .optionItems{
            @include startLine;
            flex-wrap: wrap;
        }
    }
}
.detailContent{
    width: 90%;
    margin:0 auto;
}
.home{
    width:100%;
    .header{
      background: #ffffff;
      height: 7vh;
      min-height: 60px;
      padding: 0 0px;
      @include betweenLine;
      color: white;
    }

    .homeBody{
        width: 100%;
        min-height: 75vh;

    }
    .homeBottom{
        width:100%;
        .partnerList{
            font-size: 4vh;
            width: 100%;
            @include centerLine;
            flex-direction: column;
            .partneListTitle{
                margin-top: 3vh;
                margin-bottom:3vh;
                border-bottom:2px solid #2E6DAD
            }
            .partnerListContent{
                @include startLine;
                justify-content: center;
                flex-wrap: wrap;
                width:80%;
                margin: 0 auto;
            }
        }
    }
    .ivu-modal-header{
        background: #2E6DAD
    }
}

</style>
